import Model from './model.js'

export default {
	Register:function(params){
	// console.log(params)
		Model.Register(params)
	},
  	ReadAsMaster(params) {
		if(params.action === 'SITE') {
			params.data.query = 'Location/Sites-Master/';
		} else {
			params.data.query = 'Location/Master/';
		}
		Model.ReadAsMaster(params)
	}
}



// WEBPACK FOOTER //
// ./src/App/master/import/presenter.js